// extracted by mini-css-extract-plugin
module.exports = {"userDetail":"detail_userDetail_3LcUQ","menu":"detail_menu_2ESPM","routeContent":"detail_routeContent_1FNYf"};